import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import { homeCategoriesKeys } from "../../shared/keys";
import type { Category } from "../../shared/types";

export function useCategories(initialCategories?: Category[]) {
  const locale = useLocale();

  return useQuery<Category[]>({
    queryKey: homeCategoriesKeys.categories(locale),
    queryFn: () => fetcher<Category[]>(`/${locale}/api/home/categories`),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...(initialCategories !== undefined ? { initialData: initialCategories } : {}),
  });
}
